import axios from '@/utils/request'
// 获取分组列表
export const getResourceGroup = (params)=>{
 return axios.request({
    url: 'v1/resource/group/index',
    method: 'get',
    params
  })
};

// 新增分组
export const createResourceGroup = (data)=>{
  return axios.request({
     url: 'v1/resource/group/save',
     method: 'post',
     data
   })
 };
// 删除分组
export const deleteResourceGroup = (id)=>{
  return axios.request({
     url: 'v1/resource/group/delete',
     method: 'post',
     data:{id}
   })
 };
 // 更新分组
export const updateResourceGroup = (data)=>{
  return axios.request({
     url: 'v1/resource/group/update',
     method: 'post',
     data
   })
 };

 // 上次图片
export const uploadImage = (data)=>{
  return axios.request({
     url: 'v1/resource/uploadImage',
     method: 'post',
     data
   })
 };
// 获取图片列表
export const getImage = (params)=>{
  return axios.request({
     url: 'v1/resource/image',
     method: 'get',
     params
   })
 };

 // 获取视频列表
export const getVideo = (params)=>{
  return axios.request({
     url: 'v1/resource/video',
     method: 'get',
     params
   })
 };
  // 上传视频
export const uploadVideo = (data)=>{
  return axios.request({
     url: 'v1/resource/uploadVideo',
     method: 'post',
     data
   })
 };

   // 批量删除素材
export const deleteAll = (data)=>{
  return axios.request({
     url: 'v1/resource/deleteAll',
     method: 'post',
     data
   })
 };

    // 删除单个素材
export const deleteMaterial = (data)=>{
  return axios.request({
     url: 'v1/resource/delete',
     method: 'post',
     data
   })
 };

     // 修改素材名称
export const updateName = (data)=>{
  return axios.request({
     url: 'v1/resource/updateName',
     method: 'post',
     data
   })
 };
 
      // 批量修改素材分组
export const updateGroup = (data)=>{
  return axios.request({
     url: 'v1/resource/groupUpdateAll',
     method: 'post',
     data
   })
 };